/* ─────────────────────────────────────────────────────────────────────────────
   Stitched Reviews
   Widgets: inline | anchor-badge | full | carousel
   ───────────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  if (window.__stitchedReviewsBooted) return;
  window.__stitchedReviewsBooted = true;

  // ── Helpers ────────────────────────────────────────────────────────────────

  function esc(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  var _hc = 0; // unique ID counter for half-heart gradients

  function stars(rating, sizePx) {
    var sz = sizePx || 12;
    var val = Math.max(0, Math.min(5, Number(rating) || 0));
    var full = Math.floor(val);
    var frac = val - full;
    // position of the half-filled icon (0.25–0.74 range = half); outside = full or empty
    var halfPos = (frac >= 0.25 && frac < 0.75) ? full + 1 : -1;
    var rounded = Math.round(val); // used when no half icon
    var hp = 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';

    function icon(type) {
      var b = '<svg class="sr__star" width="' + sz + '" height="' + sz + '" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">';
      var stroke = 'stroke="#c9a84c" stroke-width="1.6" stroke-linejoin="round" paint-order="stroke fill"';
      if (type === 'full') return b + '<path fill="#c9a84c" ' + stroke + ' d="' + hp + '"/></svg>';
      if (type === 'empty') return b + '<path fill="#f0e8dc" ' + stroke + ' d="' + hp + '"/></svg>';
      // half: linear gradient left=amber, right=gray
      var id = 'sr-hg-' + (++_hc);
      return b +
        '<defs><linearGradient id="' + id + '">' +
        '<stop offset="50%" stop-color="#c9a84c"/>' +
        '<stop offset="50%" stop-color="#f0e8dc"/>' +
        '</linearGradient></defs>' +
        '<path fill="url(#' + id + ')" ' + stroke + ' d="' + hp + '"/></svg>';
    }

    var out = '';
    for (var i = 1; i <= 5; i++) {
      if (i === halfPos) out += icon('half');
      else if (i <= (halfPos > 0 ? full : rounded)) out += icon('full');
      else out += icon('empty');
    }
    return out;
  }

  function formatDate(iso) {
    try { return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }); }
    catch (_) { return ''; }
  }

  function formatCount(n) {
    if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    return String(n);
  }

  function scrollTo(id) {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Renderers ──────────────────────────────────────────────────────────────

  // 1. Collection card inline badge
  function renderBadge(el, data) {
    if (!data || !data.stats) return;
    var s = data.stats;
    el.innerHTML =
      '<span class="sr__badge">' +
      '<span class="sr__stars">' + stars(s.avg, 12) + '</span>' +
      '<span class="sr__score">' + esc(Number(s.avg).toFixed(1)) + '</span>' +
      '<span class="sr__count">(' + esc(String(s.count)) + ')</span>' +
      '</span>';
  }

  // 2. Anchor badge under product title — clicking scrolls to #stitched-reviews-section
  function renderAnchorBadge(el, data) {
    if (!data || !data.stats || !data.stats.count) return;
    var s = data.stats;
    var label = s.count === 1 ? '1 review' : esc(String(s.count)) + ' reviews';
    el.classList.add('sr__has-reviews');
    el.innerHTML =
      '<span class="sr__stars">' + stars(s.avg, 14) + '</span>' +
      '<span class="sr__anchor-score">' + esc(Number(s.avg).toFixed(1)) + '</span>' +
      '<span class="sr__anchor-count">' + label + '</span>';
    el.addEventListener('click', function (e) {
      e.preventDefault();
      scrollTo('stitched-reviews-section');
    });
  }

  // 3. Full reviews widget (PDP, below the grid)
  function renderWidget(el, data) {
    if (!data || !data.stats || !data.reviews || !data.reviews.length) {
      el.innerHTML =
        '<div class="sr__widget sr__widget--empty">' +
        '<div class="sr__empty">' +
        '<svg class="sr__empty-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#c9a84c" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>' +
        '</svg>' +
        '<h3 class="sr__empty-title">No Reviews Yet</h3>' +
        '</div>' +
        '</div>';
      return;
    }
    var s = data.stats;
    var allReviews = data.reviews.slice();
    var PER_PAGE = 3; // ← change this to show more/fewer reviews per page
    var page = 0;

    var avg = Number(s.avg) || 0;
    var ratingLabel = avg >= 4.5 ? 'Exquisite' : avg >= 3.5 ? 'Splendid' : avg >= 2.5 ? 'Acceptable' : avg >= 1.5 ? 'Modest' : 'Below Expectations';

    var heartSmall = '<svg width="11" height="11" viewBox="0 0 24 24" fill="#c9a84c" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
    var distHtml = '';
    for (var star = 5; star >= 1; star--) {
      var cnt = (s.distribution && s.distribution[String(star)]) || 0;
      var pct = s.count > 0 ? Math.round((cnt / s.count) * 100) : 0;
      distHtml +=
        '<div class="sr__dist-row">' +
        '<span class="sr__dist-label">' + star + heartSmall + '</span>' +
        '<div class="sr__dist-track"><div class="sr__dist-fill" style="width:' + pct + '%"></div></div>' +
        '<span class="sr__dist-count">' + formatCount(cnt) + '</span>' +
        '</div>';
    }

    var avgHtml =
      '<div class="sr__avg-card">' +
      '<span class="sr__avg-num">' + esc(Number(s.avg).toFixed(1)) + '</span>' +
      '<div class="sr__avg-stars">' + stars(s.avg, 22) + '</div>' +
      '<span class="sr__avg-label">' + ratingLabel + '</span>' +
      '<span class="sr__avg-count">' + esc(String(s.count)) + ' ratings</span>' +
      '</div>';

    function cardHtml(r) {
      var name = r.customer_name || 'Stitched Customer';
      var date = r.created_at ? formatDate(r.created_at) : '';
      var initials = name.split(' ').map(function (p) { return p.charAt(0); }).join('').toUpperCase().slice(0, 2);
      return '<div class="sr__review">' +
        '<div class="sr__review-stars">' + stars(r.rating, 14) + '</div>' +
        (r.review_text
          ? '<p class="sr__review-text">\u201c' + esc(r.review_text) + '\u201d</p>'
          : '<p class="sr__review-text sr__review-text--empty">No written review.</p>') +
        '<div class="sr__review-meta">' +
        '<div class="sr__reviewer-avatar">' + esc(initials) + '</div>' +
        '<div class="sr__reviewer-info">' +
        '<span class="sr__reviewer">' + esc(name) + '</span>' +
        (date ? '<span class="sr__review-date">' + esc(date) + '</span>' : '') +
        '</div>' +
        '</div>' +
        '</div>';
    }

    function pagHtml(total, cur) {
      if (total <= 1) return '';
      var h = '<div class="sr__pagination">';
      h += '<button class="sr__pg-btn sr__pg-arrow sr__pg-prev" aria-label="Previous">&#8592; Prev</button>';
      for (var i = 0; i < total; i++) {
        h += '<button class="sr__pg-btn sr__pg-num' + (i === cur ? ' sr__pg-active' : '') + '" data-p="' + i + '">' + (i + 1) + '</button>';
      }
      h += '<button class="sr__pg-btn sr__pg-arrow sr__pg-next" aria-label="Next">Next &#8594;</button>';
      h += '</div>';
      return h;
    }

    function scrollToReviews() {
      var target = el.querySelector('.sr__reviews-body');
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function update(scroll) {
      var total = Math.ceil(allReviews.length / PER_PAGE);
      if (page >= total) page = Math.max(0, total - 1);
      var slice = allReviews.slice(page * PER_PAGE, (page + 1) * PER_PAGE);
      var body = el.querySelector('.sr__reviews-body');
      body.innerHTML =
        '<div class="sr__reviews">' + slice.map(cardHtml).join('') + '</div>' +
        pagHtml(total, page);
      if (scroll) scrollToReviews();
      var pag = body.querySelector('.sr__pagination');
      if (!pag) return;
      var prevBtn = pag.querySelector('.sr__pg-prev');
      var nextBtn = pag.querySelector('.sr__pg-next');
      if (prevBtn) {
        prevBtn.disabled = page === 0;
        prevBtn.addEventListener('click', function () { if (page > 0) { page--; update(true); } });
      }
      if (nextBtn) {
        nextBtn.disabled = page >= total - 1;
        nextBtn.addEventListener('click', function () { if (page < total - 1) { page++; update(true); } });
      }
      pag.querySelectorAll('.sr__pg-num').forEach(function (btn) {
        btn.addEventListener('click', function () {
          page = parseInt(this.getAttribute('data-p'), 10);
          update(true);
        });
      });
    }

    el.innerHTML =
      '<div class="sr__widget">' +
      '<h2 class="sr__heading">What Our Customers Say</h2>' +
      '<div class="sr__summary">' +
      avgHtml +
      '<div class="sr__dist">' + distHtml + '</div>' +
      '</div>' +
      '<div class="sr__reviews-body"></div>' +
      '</div>';

    update();
  }

  // 4. Review carousel
  function renderCarousel(el, data) {
    if (!data || !data.reviews || !data.reviews.length) return;
    var reviews = data.reviews;
    var multiCard = reviews.length > 1;

    var cardsHtml = reviews.map(function (r) {
      var name = r.customer_name ? esc(r.customer_name) : 'Stitched Customer';
      var text = r.review_text ? '"' + esc(r.review_text) + '"' : '';
      return '<div class="sr__c-card">' +
        '<div class="sr__c-card-stars">' + stars(r.rating, 15) + '</div>' +
        (text ? '<p class="sr__c-card-text">' + text + '</p>' : '<p class="sr__c-card-text sr__c-card-text--empty">Rated ' + r.rating + ' out of 5 stars</p>') +
        '<span class="sr__c-card-name">— ' + name + '</span>' +
        '</div>';
    }).join('');

    el.innerHTML =
      '<div class="sr__carousel">' +
      '<div class="sr__c-header">' +
      '<span class="sr__c-title">What our customers say</span>' +
      '</div>' +
      '<div class="sr__c-slider-row">' +
      (multiCard ? '<button class="sr__c-btn sr__c-btn--prev" aria-label="Previous review">&#8592;</button>' : '') +
      '<div class="sr__c-track-wrap"><div class="sr__c-track">' + cardsHtml + '</div></div>' +
      (multiCard ? '<button class="sr__c-btn sr__c-btn--next" aria-label="Next review">&#8594;</button>' : '') +
      '</div>' +
      '<div class="sr__c-footer">' +
      '<a class="sr__c-link" href="#stitched-reviews-section">See all reviews ↓</a>' +
      '</div>' +
      '</div>';

    // Click cards → scroll to full reviews
    el.querySelectorAll('.sr__c-card').forEach(function (card) {
      card.addEventListener('click', function () { scrollTo('stitched-reviews-section'); });
    });

    // Smooth scroll on "See all" link
    var seeAll = el.querySelector('.sr__c-link');
    if (seeAll) {
      seeAll.addEventListener('click', function (e) {
        e.preventDefault();
        scrollTo('stitched-reviews-section');
      });
    }

    if (!multiCard) return;

    // Carousel logic
    var track = el.querySelector('.sr__c-track');
    var prevBtn = el.querySelector('.sr__c-btn--prev');
    var nextBtn = el.querySelector('.sr__c-btn--next');
    var current = 0;
    var timer = null;

    function visibleCount() { return 1; }

    function goTo(idx) {
      var max = Math.max(0, reviews.length - visibleCount());
      current = Math.max(0, Math.min(idx, max));
      var cardW = track.children[0] ? track.children[0].offsetWidth + 12 : 0;
      track.style.transform = 'translateX(-' + (current * cardW) + 'px)';
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= max;
    }

    function startAuto() {
      timer = setInterval(function () {
        var max = Math.max(0, reviews.length - visibleCount());
        goTo(current < max ? current + 1 : 0);
      }, 4000);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { clearInterval(timer); goTo(current - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { clearInterval(timer); goTo(current + 1); startAuto(); });

    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', startAuto);

    // Init after paint so offsetWidth is available
    requestAnimationFrame(function () { goTo(0); startAuto(); });
  }

  // ── Boot ───────────────────────────────────────────────────────────────────

  function boot() {
    var elements = document.querySelectorAll(
      '[data-widget="full"], [data-widget="inline"], [data-widget="anchor-badge"], [data-widget="carousel"]'
    );
    if (!elements.length) return;

    var handleToApi = {};
    elements.forEach(function (el) {
      var h = el.getAttribute('data-handle');
      var a = el.getAttribute('data-api');
      if (h && a && !handleToApi[h]) handleToApi[h] = a;
    });

    var handles = Object.keys(handleToApi);
    if (!handles.length) return;

    var fetches = handles.map(function (handle) {
      var url = handleToApi[handle] + '/api/reviews/public?handle=' + encodeURIComponent(handle);
      return fetch(url)
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (data) { return { handle: handle, data: data }; })
        .catch(function () { return { handle: handle, data: null }; });
    });

    Promise.all(fetches).then(function (results) {
      var cache = {};
      results.forEach(function (r) { if (r.data) cache[r.handle] = r.data; });

      elements.forEach(function (el) {
        var data = cache[el.getAttribute('data-handle')];
        if (!data) return;
        var widget = el.getAttribute('data-widget');
        if (widget === 'full') renderWidget(el, data);
        else if (widget === 'carousel') renderCarousel(el, data);
        else if (widget === 'anchor-badge') renderAnchorBadge(el, data);
        else renderBadge(el, data);
      });
    });
  }

  // Run immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
